import { isNil } from 'lodash';
import React from 'react';

import AuthorizedPaidView from 'pages/Bulletin/components/AiInsights/components/GenerationLauncher/components/AuthorizedPaidView';
import AuthorizedUnpaidView from 'pages/Bulletin/components/AiInsights/components/GenerationLauncher/components/AuthorizedUnpaidView';
import UnauthorizedView from 'pages/Bulletin/components/AiInsights/components/GenerationLauncher/components/UnauthorizedView';
import { useUserInfo } from 'queries/user-action/use-user-info';

interface Props {
    onLaunch?: () => void;
    className?: string;
}

const GenerationLauncher: React.FC<Props> = ({ onLaunch, className }) => {
    const { data, isLoading } = useUserInfo();

    if (isLoading) {
        return null;
    }

    if (isNil(data)) {
        return <UnauthorizedView className={className} />;
    }

    const activeLicense = data.licenses.find(({ id, isValid }) => isValid && data.defaultLicenseId === id);

    if (isNil(activeLicense) || /free/i.test(activeLicense.licenseType)) {
        return <AuthorizedUnpaidView onLaunch={onLaunch} className={className} />;
    } else {
        return <AuthorizedPaidView onLaunch={onLaunch} className={className} />;
    }
};

export default GenerationLauncher;
